// extracted by mini-css-extract-plugin
export default {"container":"Books-module--container--2rQzp"};